import { render, staticRenderFns } from "./InvoicesDashboard.vue?vue&type=template&id=32dd8e1b&scoped=true&"
import script from "./InvoicesDashboard.vue?vue&type=script&lang=js&"
export * from "./InvoicesDashboard.vue?vue&type=script&lang=js&"
import style0 from "./InvoicesDashboard.vue?vue&type=style&index=0&id=32dd8e1b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32dd8e1b",
  null
  
)

export default component.exports